import { supabase } from "../supabaseClient";

// Best-effort push notification dispatch via Supabase Edge Function.
// Fails silently — notifications are never critical to the core flow.
export async function sendPushNotification(targetUserId, { title, body, url = "/" }) {
  if (!targetUserId) return;
  try {
    await supabase.functions.invoke("send-push-notification", {
      body: { targetUserId, title, body, url },
    });
  } catch {
    // Fail silently
  }
}
